import Container from '@mui/material/Container';

import { paths } from 'src/routes/paths';

import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';

import StationeryItemNewEditForm from '../stationery-item-new-edit-form';

export default function StationeryItemCreateView() {
  const settings = useSettingsContext();

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <CustomBreadcrumbs
        heading="Create a new stationery item"
        links={[
          {
            name: 'Stationery Items',
            href: paths.dashboard.stationeryItem.root,
          },
          { name: 'Create a new stationery item' },
        ]}
        sx={{
          mb: { xs: 3, md: 5 },
        }}
      />

      <StationeryItemNewEditForm />
    </Container>
  );
}
